import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import { Field, getFormValues, change, updateSyncErrors } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddSharpIcon from '@material-ui/icons/AddSharp';
import { Grid } from '@material-ui/core';
import styles from './styles';
import {
  selectSkillsetBuildOptions,
  selectSkillsetLookOptions,
  selectBuilderProjectGallery,
} from '../../../../store/selectors';
import {
  FILE_TYPE_ERROR,
  FORMS,
  IMAGE_SIZE_LIMIT,
  IMAGE_SIZE_LIMIT_MESSAGE,
  NOTIFICATON_LEVELS,
} from '../../../../constants';
import TextField from '../../../../fields/reduxForm/GeneralTextField';
import { getSkillsetOfType } from '../../../../store/actions/skillset';
import { postCode, required } from '../../../../utilities/validators';
import PlaceSearchFormField from '../../../../fields/reduxForm/PlaceSearchFormField';
// import PlaceSearchFormField from '../../../../fields/reduxForm/ViewablePlaceSearchFormField';
import ButtonSelectFormField from '../../../../fields/reduxForm/ButtonSelectFormField';
import JsonPlaceSearchFormField from '../../../../fields/reduxForm/JsonPlacesSearchFormField';
import ImageUploadField from '../../../../fields/reduxForm/ImageUploadField';
import {
  setBuilderProjectGalleryImages,
  removeImageBuilderProjectGalleryImages,
} from '../../../../store/actions/builderPics';
import { addNotification } from '../../../../store/actions/notification';

const propTypes = {
  classes: PropTypes.shape({
    cardHeaderRoot: PropTypes.string,
    cardHeaderTitle: PropTypes.string,
    formGroup: PropTypes.string,
    halfFormGroup: PropTypes.string,
    formRow: PropTypes.string,
  }).isRequired,
  onGetSkillsetOfType: PropTypes.func.isRequired,
  skillsetBuildOptions: PropTypes.array.isRequired,
  skillsetLookOptions: PropTypes.array.isRequired,
  isBuilder: PropTypes.bool.isRequired,
};

export const imageHandler = (file, action) => {
  const reader = new FileReader();
  reader.onloadend = () => {
    action(reader.result, file);
  };
  reader.readAsDataURL(file[0]);
};

export const FieldsGroupTwo = props => {
  const {
    classes,
    onGetSkillsetOfType,
    skillsetBuildOptions,
    skillsetLookOptions,
    isBuilder,
    changeFieldValue,
    formValues,
    builderProjectGallery,
    setProjectGalleryImages,
    removeImageFromBuilderProjectGalleryImages,
    onAddNotification,
  } = props;
  useEffect(() => {
    if (!skillsetBuildOptions.length) onGetSkillsetOfType('build');
    if (!skillsetLookOptions.length) onGetSkillsetOfType('look');
  }, []);

  const builderPhotoInputRef = useRef();
  const builderBannerInputRef = useRef();
  const projectGalleryInputRef = useRef();

  const [previewBuilderPhoto, setPreviewBuilderPhoto] = useState();
  const [previewBuilderBanner, setPreviewBuilderBanner] = useState();
  // const [previewProjectGallery, setPreviewProjectGallery] = useState([]);

  const projectGalleryImagesHandler = files => {
    if (files && files.length) {
      console.log(files);
      const invalidIndexes = [];
      let hasInvalidFileSize = false;
      let hasInvalidFileType = false;
      files.forEach((file, index) => {
        if (file.size > IMAGE_SIZE_LIMIT) {
          invalidIndexes.push(index);
          hasInvalidFileSize = true;
        }
        if (!file.type.includes('image/')) {
          invalidIndexes.push(index);
          hasInvalidFileType = true;
        }
      });
      let filteredFiles = files;
      if (invalidIndexes.length > 0) {
        filteredFiles = [...files].filter(
          (_, index) => !invalidIndexes.includes(index),
        );
      }

      console.log('Filtered', filteredFiles);
      if (hasInvalidFileType) {
        onAddNotification(FILE_TYPE_ERROR, NOTIFICATON_LEVELS.ERROR);
      } else if (hasInvalidFileSize) {
        onAddNotification(IMAGE_SIZE_LIMIT_MESSAGE, NOTIFICATON_LEVELS.ERROR);
      }
      filteredFiles.forEach(file => {
        imageHandler([file], projectGalleryImagesCollector);
      });
    }
  };
  const projectGalleryImagesCollector = (image, file) => {
    // setPreviewProjectGallery(prevArray => [...prevArray, image]);
    setProjectGalleryImages({ file, image });
  };

  useEffect(() => {
    if (formValues) {
      if (formValues.logo) {
        if (!formValues.logo[0].type.includes('image/')) {
          onAddNotification(FILE_TYPE_ERROR, NOTIFICATON_LEVELS.ERROR);
          return;
        }
        if (formValues.logo[0].size > IMAGE_SIZE_LIMIT) {
          onAddNotification(IMAGE_SIZE_LIMIT_MESSAGE, NOTIFICATON_LEVELS.ERROR);
          builderPhotoInputRef.current.value = null;
        } else {
          imageHandler(formValues.logo, setPreviewBuilderPhoto);
        }
      }
      if (formValues.coverPhoto) {
        if (!formValues.coverPhoto[0].type.includes('image/')) {
          onAddNotification(FILE_TYPE_ERROR, NOTIFICATON_LEVELS.ERROR);
          return;
        }
        if (formValues.coverPhoto[0].size > IMAGE_SIZE_LIMIT) {
          onAddNotification(IMAGE_SIZE_LIMIT_MESSAGE, NOTIFICATON_LEVELS.ERROR);
          builderBannerInputRef.current.value = null;
        } else imageHandler(formValues.coverPhoto, setPreviewBuilderBanner);
      }
    }
  }, [formValues]);

  return (
    <Card>
      <CardHeader
        classes={{
          root: classes.cardHeaderRoot,
          title: classes.cardHeaderTitle,
        }}
        title="Step2: Business Details"
      />
      <CardContent>
        {isBuilder && (
          <div className={classes.topImageFormGroup}>
            {/* <div
            // className={classNames(classes.formGroup, classes.halfFormGroup)}
            > */}
            <div className={classes.topImageSingle}>
              {previewBuilderPhoto ? (
                <div className={classes.imageOuterContainer}>
                  <div className={classes.imageContainer}>
                    <img
                      src={previewBuilderPhoto}
                      alt="builder profile"
                      className={classes.profilePhoto}
                    />
                    <Grid
                      className={classes.remove}
                      onClick={() => {
                        setPreviewBuilderPhoto(null);
                        // setBuilderPhoto(null);
                        builderPhotoInputRef.current.value = null;
                        changeFieldValue('logo', null);
                      }}
                    >
                      x
                    </Grid>
                  </div>
                </div>
              ) : (
                <Grid
                  className={classes.photoUpload}
                  onClick={() => builderPhotoInputRef.current.click()}
                >
                  <AddSharpIcon />
                  Add Image
                </Grid>
              )}
              <p className={classes.textLabel}>Profile Image</p>
              <Field
                component={ImageUploadField}
                name="logo"
                props={{
                  id: 'builder-profile',
                }}
                reference={builderPhotoInputRef}
              />
            </div>
            <div className={classes.topImageSingle}>
              {previewBuilderBanner ? (
                <div>
                  <div className={classes.imageContainer}>
                    <>
                      <img
                        src={previewBuilderBanner}
                        alt="builder profile"
                        className={classes.profilePhoto}
                      />
                    </>
                    <Grid
                      className={classes.remove}
                      onClick={() => {
                        // setBuilderBanner(null);
                        setPreviewBuilderBanner(null);
                        builderBannerInputRef.current.value = null;
                        changeFieldValue('coverPhoto', null);
                      }}
                    >
                      x
                    </Grid>
                  </div>
                </div>
              ) : (
                <Grid
                  className={classes.photoUpload}
                  onClick={() => builderBannerInputRef.current.click()}
                >
                  <AddSharpIcon />
                  Add Image
                </Grid>
              )}
              <p className={classes.textLabel}>Cover Photo</p>

              <Field
                component={ImageUploadField}
                name="coverPhoto"
                props={{
                  ref: builderBannerInputRef,
                  id: 'builder-banner',
                }}
                reference={builderBannerInputRef}
              />
            </div>
          </div>
        )}
        <div className={classes.formRow}>
          <div className={classNames(classes.formGroup, classes.halfFormGroup)}>
            <Field
              name="custom:businessName"
              component={TextField}
              props={{
                id: 'business-name-text-field',
                label: 'Business Name',
                fullWidth: true,
                required: true,
              }}
              validate={[required]}
            />
          </div>
          <div className={classNames(classes.formGroup, classes.halfFormGroup)}>
            <Field
              name="custom:position"
              component={TextField}
              props={{
                id: 'position-text-field',
                label: isBuilder ? 'Position' : 'Position (optional)',
                fullWidth: true,
                required: isBuilder,
              }}
              validate={isBuilder ? [required] : []}
            />
          </div>
        </div>
        <div className={classes.formRow}>
          <div className={classes.formGroup}>
            <Field
              name="custom:profileHeadline"
              component={TextField}
              props={{
                id: 'profile-description-text-field',
                label: isBuilder
                  ? 'Profile Description'
                  : 'Profile Description (optional)',
                fullWidth: true,
                required: isBuilder,
                inputProps: {
                  maxLength: 240,
                },
              }}
              validate={isBuilder ? [required] : []}
              multiline
              rows={2}
            />
          </div>
        </div>
        {isBuilder && (
          <div className={classes.formRow}>
            <div className={classes.formGroup}>
              <div className={classes.galleryContainer}>
                <p className={classes.textLabel}>Project Gallery</p>
                <div className={classes.galleryImages}>
                  <Grid
                    className={classes.photoUpload}
                    onClick={() => projectGalleryInputRef.current.click()}
                  >
                    <AddSharpIcon />
                    Add Images
                  </Grid>
                  {builderProjectGallery.length > 0 &&
                    builderProjectGallery.map((image, index) => (
                      <div className={classes.imageContainer}>
                        <>
                          <img
                            src={image.image}
                            alt="project-gallery"
                            className={classes.profilePhoto}
                          />
                        </>
                        <Grid
                          className={classes.remove}
                          onClick={() => {
                            const arr = builderProjectGallery;
                            arr.splice(index, 1);
                            removeImageFromBuilderProjectGalleryImages(index);
                          }}
                        >
                          x
                        </Grid>
                      </div>
                    ))}
                </div>
                <input
                  ref={projectGalleryInputRef}
                  type="file"
                  accept="image/*"
                  multiple="multiple"
                  id="project-gallery"
                  name="custom:gallery"
                  style={{ display: 'none' }}
                  onChange={e => projectGalleryImagesHandler(e.target.files)}
                />
              </div>
            </div>
          </div>
        )}

        <div
          className={classes.formRow}
          data-test="business-address-field-group"
        >
          <div className={classes.formGroup}>
            <Field
              name="custom:businessAddress"
              component={PlaceSearchFormField}
              props={{
                id: 'business-mailing-address-text-field',
                label: isBuilder
                  ? 'Business Mailing Address *'
                  : 'Business Mailing Address (optional)',
                fullWidth: true,
                required: isBuilder,
              }}
              validate={isBuilder ? [required] : []}
            />
          </div>
        </div>
        {!isBuilder && (
          <div className={classes.formRow} data-test="postcode-field-group">
            <div className={classes.formGroup}>
              <Field
                name="custom:postcode"
                component={TextField}
                props={{
                  id: 'postcode-text-field',
                  label: 'Postcode',
                  fullWidth: true,
                  required: true,
                }}
                validate={[required, postCode]}
              />
            </div>
          </div>
        )}
        {isBuilder && (
          <>
            <div className={classNames(classes.formGroup)}>
              <Field
                name="custom:materialLocation"
                component={JsonPlaceSearchFormField}
                props={{
                  id: 'materialLocation-text-field',
                  label:
                    'Where do you plan to purchase James Hardie products for your next project? *',
                  fullWidth: true,
                  additionalRestrictions: { types: ['establishment'] },
                  required: true,
                }}
                validate={[required]}
              />
            </div>
            {/* {isBuilder && (
              <div className={classes.formRow} data-test="googlePlaceField">
                <div className={classes.formGroup}>
                  <Field
                    name="custom:googlePlaceField"
                    component={PlaceSearchFormField}
                    onAddress={address => {
                      if (address)
                        changeFieldValue(
                          'custom:googlePlaceId',
                          address.place_id,
                        );
                    }}
                    props={{
                      id: 'material-location-text-field',
                      label: 'Google Business Listing',
                      additionalRestrictions: { types: ['establishment'] },
                      floatingLabelFixed: true,
                      fullWidth: true,
                    }}
                  />
                </div>
                <Field
                  name="custom:googlePlaceId"
                  component={HiddenTextField}
                  props={{
                    id: 'google-place-id',
                    fullWidth: true,
                  }}
                />
              </div>
            )} */}
            <div
              className={classes.formRow}
              data-test="skillsetBuildOptions-field-group"
            >
              <div className={classes.formGroup}>
                {skillsetBuildOptions.length <= 0 && (
                  <div className={classes.textCenter}>
                    <CircularProgress size={20} />
                  </div>
                )}
                {skillsetBuildOptions.length > 0 && (
                  <Field
                    name="custom:skillsetBuild"
                    component={ButtonSelectFormField}
                    props={{
                      id: 'skillset-build-field',
                      label: 'SELECT THE TYPE OF BUILDS THAT YOU DO',
                    }}
                    options={skillsetBuildOptions}
                  />
                )}
              </div>
            </div>
            <div
              className={classes.formRow}
              data-test="skillsetLookOptions-field-group"
            >
              <div className={classes.formGroup}>
                {skillsetLookOptions.length <= 0 && (
                  <div className={classes.textCenter}>
                    <CircularProgress size={20} />
                  </div>
                )}
                {skillsetLookOptions.length > 0 && (
                  <Field
                    name="custom:skillsetLook"
                    component={ButtonSelectFormField}
                    props={{
                      id: 'skillset-look-field',
                      label: 'SELECT THE LOOKS THAT YOU CAN ACHIEVE',
                    }}
                    options={skillsetLookOptions}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
};

FieldsGroupTwo.propTypes = propTypes;

const mapStateToProps = state => ({
  formValues: getFormValues(FORMS.REGISTRATION_LONG)(state),
  skillsetBuildOptions: selectSkillsetBuildOptions()(state),
  skillsetLookOptions: selectSkillsetLookOptions()(state),
  builderProjectGallery: selectBuilderProjectGallery()(state),
});

const mapDispatchToProps = dispatch => ({
  onGetSkillsetOfType: type => dispatch(getSkillsetOfType(type)),
  setProjectGalleryImages: image =>
    dispatch(setBuilderProjectGalleryImages(image)),
  removeImageFromBuilderProjectGalleryImages: index =>
    dispatch(removeImageBuilderProjectGalleryImages(index)),
  changeFieldValue: (field, value) =>
    dispatch(change(FORMS.REGISTRATION_LONG, field, value)),
  updateFieldError: (field, value) =>
    dispatch(updateSyncErrors(FORMS.REGISTRATION_LONG, { [field]: value })),
  onAddNotification: (message, level, autoHideDuration) =>
    dispatch(addNotification(message, level, autoHideDuration)),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(FieldsGroupTwo),
);
